const UserIconFilled = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg" width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="currentColor"
    >
        <path
            d="M5.11414 5.11363C5.11414 2.96999 6.85687 1.22726 9.0005 1.22726C11.1441 1.22726 12.8869 2.96999 12.8869 5.11363C12.8869 7.25726 11.1441 8.99999 9.0005 8.99999C6.85687 8.99999 5.11414 7.25726 5.11414 5.11363Z"
            fill="currentColor"
        />
        <path
            d="M2.22598 15.7418C2.45507 16.1345 2.84779 16.3636 3.28143 16.3636H14.7032C15.1369 16.3636 15.5296 16.1345 15.7587 15.7418C15.9878 15.3654 16.0042 14.8991 15.8242 14.5064C14.7278 12.1582 11.856 10.6364 8.99234 10.6364C6.1287 10.6364 3.25689 12.15 2.16052 14.5064C1.98052 14.9073 2.00507 15.3654 2.22598 15.7418Z"
            fill="currentColor"
        />
    </svg>
);

export default UserIconFilled;
